<template>
  <router-view/>
</template>

<script>
import { provide, ref, computed, reactive } from 'vue';

import * as Sound from "./game/sound.js";

export default {
  setup() {

    let [ sound, sfxPromise ] = Sound.initSound();
    console.log("sound", sound);
    provide("sound", sound);
    provide("sfxPromise", sfxPromise);


    let preferences = {
      background: "dark",
      defaultDifficulty: "easy",
    };

    try { preferences = JSON.parse(localStorage["masterpieces_preferences"]); } catch {}

    provide("userPreferences", reactive(preferences));
    provide("setBackgroundPreferences", pref => {
      preferences.background = pref;
      localStorage["masterpieces_preferences"] = JSON.stringify(preferences);
    });
    provide("setDifficultyPreferences", pref => {
      preferences.defaultDifficulty = pref;
      localStorage["masterpieces_preferences"] = JSON.stringify(preferences);
    });


    let gain = computed(() => floor(100*sound.master.gain.value));
    provide("setGain", gain => {
      let value = gain/100;
      sound.master.gain.setValueAtTime(value, 0);
      sound.cfg.master = value;
      localStorage["masterpieces_audio_config"] = JSON.stringify(sound.cfg);
    });
  }
}
</script>

<style lang="scss">

</style>
